export enum FeaturedType {
  Private = 0,
  Public = 1,
  Featured = 2,
}

export enum ResourceType {
  Model = "NetPyNE",
  Experiment = "NWB Explorer",
  Generic = "Jupyter Lab",
  Folder = "Folder",
}
